import { defineStore } from 'pinia'

import type { OptionsStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useOptionsStore = defineStore('options', {
  state: (): OptionsStore => ({
    options: null,
  }),
  actions,
  getters,
})
